export default {
	name: "link-customer-shipping-addresses-to-sales-rep-modal",
	props: ["showModal", "userId"],
	emits: ["modalClose"],
	data() {
		return {
			modalHeading: "Link Customer Shipping Addresses to Sales Rep",
			modalComponentId: "linkCustomerShippingAddressesToSalesRepModal",
			salesRepCustomers: [],
			searchQuery: null,
			shippingAddressSearchQuery: null,
			salesRepCustomersHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
				{
					text: "Phone Number",
					field: "primaryTelephoneNumber"
				}
			],
			assignedFilterStateChanged: false,
			salesRep: {},
			loading: false,
			pagingSalesRepCustomersDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			selectedCompany: {},
			companyShippingAddresses: [],
			shippingAddressHeadings: [
				{
					text: "Site Name",
					field: "siteName"
				},
				{
					text: "Street Address",
					field: "streetAddress"
				},
				{
					text: "City",
					field: "city"
				},
				{
					text: "Postal Code",
					field: "postalCode"
				}
			],
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
		};
	},
	methods: {
		getUser(){
			this.loading = true;
			securityService.getUser(this.userId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.salesRep = successResponse.data.result;
					}
					//this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					//this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getSalesRepCustomers(){
			this.loading = true;
			let request = {
				userId: this.userId,
				pageNumber: this.pagingSalesRepCustomersDetails.pageNumber,
				pageSize: this.pagingSalesRepCustomersDetails.pageSize,
				isActive: true,
				searchQuery: this.searchQuery
			};
			securityService.getCompaniesAssignedToSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.salesRepCustomers = successResponse.data.result;
						this.pagingSalesRepCustomersDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingSalesRepCustomersDetails.totalPages = successResponse.data.pagingInfo.totalPages;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompanyShippingAddressesAssignedToSalesRep(){
			this.loading = true;
			let request = {
				userId: this.userId,
				companyId: this.selectedCompany.companyId,
				searchQuery: this.shippingAddressSearchQuery
			};
			securityService.getCompanyShippingAddressesAssignedToSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.companyShippingAddresses = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onCompanySelectClick(companyId, registeredCompanyName){
			this.selectedCompany = {
				companyId: companyId,
				registeredCompanyName: registeredCompanyName
			};
			this.getCompanyShippingAddressesAssignedToSalesRep();
		},
		onShippingAddressSelect(companyAddressId){
			let companyAddress = this.companyShippingAddresses.find(companyAddress => companyAddress.companyAddressId === companyAddressId);
			companyAddress.isAssigned = !companyAddress.isAssigned;
		},
		onBackToCustomerSelectClick(){
			this.clearMessageAlerts();
			this.selectedCompany = {};
			this.companyShippingAddresses = [];
		},
		onModalCloseClick(){
			this.clearMessageAlerts();
			this.selectedCompany = {};
			this.companyShippingAddresses = [];
			this.$emit("modalClose");
		},
		onModalSaveClick(){
			this.loading = true;
			let companyAddressIdsToAssign = this.companyShippingAddresses.filter(companyAddress => companyAddress.isAssigned).map(companyAddress => companyAddress.companyAddressId);
			let companyAddressIdsToUnassign = this.companyShippingAddresses.filter(companyAddress => !companyAddress.isAssigned).map(companyAddress => companyAddress.companyAddressId);
			let request = {
				userId: this.userId,
				companyAddressIdsToAssign: companyAddressIdsToAssign,
				companyAddressIdsToUnassign: companyAddressIdsToUnassign
			};
			securityService.assignAndUnassignCompanyAddressesFromSalesRep(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.showSuccessMessage = true;
						this.successMessage = "Company shipping addresses assigned to sales rep successfully.";
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = "Something went wrong while attempting to assign company shipping addresses to sales rep.";
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					this.showErrorMessage = true;
					this.errorMessage = "Unexpected error occurred";
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			//this.$emit("modalClose", true);
		},
	},
	mounted: function () {
		
	},
	watch:{
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalComponentId).modal("show");
				}
				else{
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		userId:{
			handler: function () {
				if(this.userId !== null && this.userId > 0){
					this.getUser();
					this.getSalesRepCustomers();
				}
			},
			immediate: true,
			deep: true
		}
	}
};